<template>
  <div class="agendaAgronomica">
    <!-- <header class="agendaHeader">
      <div>
        <h2>Agenda de visitas</h2>
        <small
          >Planeje e inicie visitas técnicas sem perder o vínculo com o
          histórico.</small
        >
      </div>
      <div class="agendaActions">
        <button class="btnToday" @click="goToday">Hoje</button>
        <button class="btnPrimary" @click="openForm()">
          <b-icon-plus /> Agendar visita
        </button>
      </div>
    </header> -->

    <section class="summaryGrid">
      <div class="summaryCard">
        <span class="summaryIcon"><b-icon-calendar-check /></span
        ><strong>{{ todayItems.length }}</strong
        ><span>Visitas hoje</span>
      </div>
      <div class="summaryCard warning">
        <span class="summaryIcon"><b-icon-arrow-repeat /></span
        ><strong>{{ overdueReturns.length }}</strong
        ><span>Retornos atrasados</span>
      </div>
      <div class="summaryCard danger">
        <span class="summaryIcon"><b-icon-exclamation-triangle /></span
        ><strong>{{ overduePending.length }}</strong
        ><span>Pendências vencidas</span>
      </div>
      <div class="summaryCard info">
        <span class="summaryIcon"><b-icon-clock-history /></span
        ><strong>{{ awaitingFollowUp.length }}</strong
        ><span>Aguardam acompanhamento</span>
      </div>
    </section>

    <div class="toolbar">
      <div class="navigation">
        <button @click="navigate(-1)">‹</button>
        <strong>{{ periodLabel }}</strong>
        <button @click="navigate(1)">›</button>
      </div>
      <div class="viewButtons">
        <button
          v-for="view in views"
          :key="view.value"
          :class="{ active: currentView === view.value }"
          @click="currentView = view.value"
        >
          {{ view.text }}
        </button>
      </div>
    </div>

    <div v-if="currentView === 'month'" class="monthGrid">
      <div v-for="name in weekNames" :key="name" class="weekName">
        {{ name }}
      </div>
      <div
        v-for="day in monthDays"
        :key="day.key"
        class="monthDay"
        :class="{ muted: !day.currentMonth, today: day.isToday }"
        @click="openForm(null, day.date)"
      >
        <b>{{ day.number }}</b>
        <button
          v-for="item in itemsForDate(day.iso).slice(0, 3)"
          :key="item.id"
          class="eventChip"
          :class="statusClass(item.status)"
          @click.stop="openForm(item)"
        >
          {{ item.allDay ? "Dia inteiro" : item.startTime }} · {{ item.title }}
        </button>
        <small v-if="itemsForDate(day.iso).length > 3"
          >+ {{ itemsForDate(day.iso).length - 3 }} compromisso(s)</small
        >
      </div>
    </div>

    <div v-else-if="currentView === 'list'" class="listView">
      <article
        v-for="item in filteredItems"
        :key="item.id"
        class="listItem"
        :class="statusClass(item.status)"
        @click="openForm(item)"
      >
        <div class="dateBox">
          <b>{{ formatDay(item.date) }}</b
          ><small>{{ formatMonth(item.date) }}</small>
        </div>
        <div class="grow">
          <b>{{ item.title }}</b
          ><span
            >{{ item.type }} ·
            {{ item.customerName || "Produtor não informado" }} ·
            {{ item.property || "Propriedade não informada" }}</span
          >
        </div>
        <span>{{
          item.allDay ? "Dia inteiro" : `${item.startTime}–${item.endTime}`
        }}</span
        ><em>{{ item.status }}</em>
      </article>
      <div v-if="!filteredItems.length" class="empty">
        Nenhum compromisso no período.
      </div>
    </div>

    <div v-else class="dayView">
      <div v-for="day in visibleDays" :key="day.iso" class="dayColumn">
        <h3>
          {{ day.label }} <b>{{ day.number }}</b>
        </h3>
        <button class="addDay" @click="openForm(null, day.date)">
          + adicionar
        </button>
        <article
          v-for="item in itemsForDate(day.iso)"
          :key="item.id"
          class="scheduleCard"
          :class="statusClass(item.status)"
          @click="openForm(item)"
        >
          <b
            >{{ item.allDay ? "Dia inteiro" : item.startTime }} ·
            {{ item.title }}</b
          >
          <span>{{ item.customerName || "Sem produtor" }}</span
          ><small>{{ item.type }} · {{ item.status }}</small>
          <button
            v-if="!['Concluído', 'Cancelado'].includes(item.status)"
            class="startVisit"
            :disabled="startingVisitId !== null"
            @click.stop="startVisit(item)"
          >
            <b-spinner v-if="startingVisitId === item.id" small />
            <b-icon-play-fill v-else />
            {{ startingVisitId === item.id ? "Iniciando..." : "Iniciar visita" }}
          </button>
        </article>
      </div>
    </div>

    <b-modal
      id="agronomic-commitment-modal"
      v-model="showForm"
      size="lg"
      hide-footer
      :title="form.id ? 'Editar agendamento' : 'Agendar visita técnica'"
      header-class="modalHeader"
      body-class="modalBody"
    >
      <form class="commitmentForm" @submit.prevent="save">
        <div class="formSection">
          <h4 class="formSectionTitle">Dados do compromisso</h4>
          <label class="fieldFull">Título da visita
            <input v-model.trim="form.title" required placeholder="Ex: Monitoramento de pragas" />
          </label>
          <label>Tipo de compromisso
            <select v-model="form.type" required>
              <option v-for="item in types" :key="item">{{ item }}</option>
            </select>
          </label>
          <label>Data
            <input v-model="form.date" type="date" required />
          </label>
          <label class="check">
            <input v-model="form.allDay" type="checkbox" /> Dia inteiro
          </label>
          <label v-if="!form.allDay">Horário inicial
            <input v-model="form.startTime" type="time" required />
          </label>
          <label v-if="!form.allDay">Horário final
            <input v-model="form.endTime" type="time" required />
          </label>
          <div class="referenceField">
            <div class="referenceMode">
              <span>Responsável</span>
              <button type="button" @click="toggleReferenceMode('responsible')">
                {{ referenceModes.responsible === "registered" ? "Digitar novo" : "Usar cadastro" }}
              </button>
            </div>
            <InputSelect
              v-if="referenceModes.responsible === 'registered'"
              label=""
              :items="technicalManagers"
              valueField="id"
              textField="nome"
              :enableIconCreate="false"
              :dataInput="form.responsibleId"
              :dataSelect.sync="form.responsibleId"
              @selectedCompletedItem="handleResponsibleSelection"
            />
            <input
              v-else
              v-model.trim="form.responsible"
              required
              placeholder="Nome do profissional"
            />
          </div>
        </div>

        <div class="formSection">
          <h4 class="formSectionTitle">Classificação</h4>
          <label>Prioridade
            <select v-model="form.priority">
              <option>Baixa</option>
              <option>Normal</option>
              <option>Alta</option>
              <option>Urgente</option>
            </select>
          </label>
          <label>Status
            <select v-model="form.status">
              <option v-for="item in statuses" :key="item">{{ item }}</option>
            </select>
          </label>
          <label>Lembrete
            <select v-model="form.reminder">
              <option>Sem lembrete</option>
              <option>15 minutos antes</option>
              <option>30 minutos antes</option>
              <option>1 hora antes</option>
              <option>1 dia antes</option>
            </select>
          </label>
        </div>

        <div class="formSection">
          <h4 class="formSectionTitle">Dados do produtor</h4>
          <div class="referenceField">
            <div class="referenceMode">
              <span>Cliente / Produtor</span>
              <button type="button" @click="toggleReferenceMode('customer')">
                {{ referenceModes.customer === "registered" ? "Digitar novo" : "Usar cadastro" }}
              </button>
            </div>
            <InputInfinit
              v-if="referenceModes.customer === 'registered'"
              :key="`schedule-customer-${formKey}`"
              label="Cliente cadastrado"
              typeFilter="customer"
              :isEdit="form.customerId"
              :dataInput.sync="form.customerId"
              :onSearch="fillCustomers"
              :enableIconCreate="false"
              :filterIsEnable="false"
              :showLabel="false"
              :noPadding="true"
              @selectItem="handleCustomerSelection"
            />
            <input
              v-else
              v-model.trim="form.customerName"
              required
              placeholder="Nome do produtor"
            />
          </div>
          <div class="referenceField">
            <div class="referenceMode">
              <span>Propriedade</span>
              <button type="button" @click="toggleReferenceMode('property')">
                {{ referenceModes.property === "registered" ? "Digitar nova" : "Usar cadastro" }}
              </button>
            </div>
            <InputSelect
              v-if="referenceModes.property === 'registered'"
              label=""
              :items="properties"
              valueField="id"
              textField="nome"
              :enableIconCreate="false"
              :isDisabled="!form.customerId"
              :dataInput="form.propertyId"
              :dataSelect.sync="form.propertyId"
              @selectedCompletedItem="handlePropertySelection"
            />
            <input
              v-else
              v-model.trim="form.property"
              required
              placeholder="Nome da propriedade"
            />
          </div>
          <div class="referenceField">
            <div class="referenceMode">
              <span>Cultura</span>
              <button type="button" @click="toggleReferenceMode('culture')">
                {{ referenceModes.culture === "registered" ? "Digitar nova" : "Usar cadastro" }}
              </button>
            </div>
            <InputInfinit
              v-if="referenceModes.culture === 'registered'"
              :key="`schedule-culture-${formKey}`"
              label="Cultura do Compêndio"
              typeFilter="culture"
              :isEdit="form.cultureId"
              :dataInput.sync="form.cultureId"
              :onSearch="fillCultures"
              :enableIconCreate="false"
              :filterIsEnable="false"
              :showLabel="false"
              :noPadding="true"
              @selectItem="handleCultureSelection"
            />
            <input
              v-else
              v-model.trim="form.crop"
              required
              placeholder="Ex: Soja, Milho"
            />
          </div>
          <label>Talhão
            <input v-model.trim="form.field" required placeholder="Ex: Talhão 1" />
          </label>
        </div>

        <div class="formSection fieldFull">
          <h4 class="formSectionTitle">Observações</h4>
          <textarea v-model.trim="form.notes" rows="3" placeholder="Detalhes adicionais sobre o compromisso..."></textarea>
        </div>

        <div class="formActions">
          <button
            v-if="form.id && form.status !== 'Cancelado'"
            type="button"
            class="btnDanger"
            :disabled="isSaving || isCancelling"
            @click="cancel"
          >
            {{ isCancelling ? "Cancelando..." : "Cancelar compromisso" }}
          </button>
          <span class="spacer"></span>
          <button
            type="button"
            class="btnSecondary"
            :disabled="isSaving || isCancelling"
            @click="showForm = false"
          >
            Fechar
          </button>
          <button class="btnPrimary" type="submit" :disabled="isSaving || isCancelling">
            <b-spinner v-if="isSaving" small />
            <b-icon-check2 v-else />
            {{ isSaving ? "Salvando..." : "Salvar" }}
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import InputInfinit from "../UI/CustomInputs/InputInfinit.vue";
import serviceCustomer from "../../services/serviceCustomer";
import serviceResponsible from "../../services/serviceResponsible";
import serviceCustomerProperty from "../../services/serviceCustomerProperty";
import serviceCompendio from "../../services/serviceCompendio";
import {
  cancelCommitment as apiCancel,
  listAttendances as apiListAttendances,
  listCommitments as apiListCommitments,
  saveCommitment as apiSave,
  startVisit as apiStartVisit,
} from "../../services/agronomicAgenda";

const blank = (date) => ({
  id: null,
  type: "Visita técnica",
  title: "Visita técnica",
  date,
  startTime: "08:00",
  endTime: "09:00",
  allDay: false,
  responsible: "",
  priority: "Normal",
  status: "Agendado",
  reminder: "30 minutos antes",
  notes: "",
  customerId: "",
  customerName: "",
  responsibleId: "",
  property: "",
  propertyId: "",
  crop: "",
  cultureId: "",
  field: "",
  diagnosticos: [],
});

export default {
  name: "NewSchedule",
  components: { InputSelect, InputInfinit },
  data() {
    return {
      cursor: DateTime.now(),
      currentView: "week",
      showForm: false,
      form: blank(DateTime.now().toISODate()),
      commitments: [],
      attendances: [],
      technicalManagers: [],
      properties: [],
      formKey: 0,
      isSaving: false,
      isCancelling: false,
      startingVisitId: null,
      referenceModes: {
        customer: "registered",
        responsible: "registered",
        property: "registered",
        culture: "registered",
      },
      views: [
        { value: "day", text: "Dia" },
        { value: "week", text: "Semana" },
        { value: "month", text: "Mês" },
        { value: "list", text: "Lista" },
      ],
      weekNames: ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"],
      types: [
        "Visita técnica",
        "Retorno/acompanhamento",
        "Monitoramento",
        "Coleta de amostra",
        "Acompanhamento de aplicação",
        "Consultoria/reunião",
        "Vistoria",
        "Outro",
      ],
      statuses: [
        "Agendado",
        "Confirmado",
        "Em atendimento",
        "Concluído",
        "Reagendado",
        "Cancelado",
      ],
    };
  },
  computed: {
    periodStart() {
      if (this.currentView === "day") return this.cursor.startOf("day");
      if (this.currentView === "month") return this.cursor.startOf("month");
      return this.cursor.startOf("week").minus({ days: 1 });
    },
    periodEnd() {
      if (this.currentView === "day") return this.cursor.endOf("day");
      if (this.currentView === "month") return this.cursor.endOf("month");
      return this.periodStart.plus({ days: 6 }).endOf("day");
    },
    periodLabel() {
      return this.currentView === "day"
        ? this.cursor.setLocale("pt-BR").toFormat("dd 'de' LLLL 'de' yyyy")
        : `${this.periodStart.toFormat("dd/MM")} – ${this.periodEnd.toFormat(
            "dd/MM/yyyy"
          )}`;
    },
    visibleDays() {
      const start = this.currentView === "day" ? this.cursor : this.periodStart;
      const length = this.currentView === "day" ? 1 : 7;
      return Array.from({ length }, (_, i) => {
        const date = start.plus({ days: i });
        return {
          date,
          iso: date.toISODate(),
          number: date.day,
          label: date.setLocale("pt-BR").toFormat("ccc").toUpperCase(),
        };
      });
    },
    monthDays() {
      const start = this.cursor
        .startOf("month")
        .startOf("week")
        .minus({ days: 1 });
      return Array.from({ length: 42 }, (_, i) => {
        const date = start.plus({ days: i });
        return {
          key: date.toISODate(),
          date,
          iso: date.toISODate(),
          number: date.day,
          currentMonth: date.month === this.cursor.month,
          isToday: date.hasSame(DateTime.now(), "day"),
        };
      });
    },
    filteredItems() {
      return this.commitments
        .filter((item) => {
          const date = DateTime.fromISO(item.date);
          return date >= this.periodStart && date <= this.periodEnd;
        })
        .sort((a, b) =>
          `${a.date}${a.startTime}`.localeCompare(`${b.date}${b.startTime}`)
        );
    },
    todayItems() {
      return this.commitments.filter(
        (item) =>
          item.date === DateTime.now().toISODate() &&
          item.status !== "Cancelado"
      );
    },
    overdueReturns() {
      const today = DateTime.now().toISODate();
      return this.commitments.filter(
        (item) =>
          item.type === "Retorno/acompanhamento" &&
          item.date < today &&
          !["Concluído", "Cancelado"].includes(item.status)
      );
    },
    overduePending() {
      const today = DateTime.now().toISODate();
      return this.attendances
        .flatMap((item) => item.pendingActions || [])
        .filter(
          (item) =>
            item.deadline &&
            item.deadline < today &&
            !["Resolvido", "Cancelado"].includes(item.status)
        );
    },
    awaitingFollowUp() {
      return this.attendances.filter(
        (item) =>
          item.status === "Concluído" &&
          item.followUpRequired &&
          !item.followUpCommitmentId
      );
    },
  },
  created() {
    this.load();
    this.loadTechnicalManagers();
    window.addEventListener("agronomic-agenda-updated", this.load);
  },
  beforeDestroy() {
    window.removeEventListener("agronomic-agenda-updated", this.load);
  },
  methods: {
    async load() {
      this.commitments = await apiListCommitments();
      this.attendances = await apiListAttendances();
    },
    navigate(direction) {
      const unit =
        this.currentView === "day"
          ? "days"
          : this.currentView === "month"
          ? "months"
          : "weeks";
      this.cursor = this.cursor.plus({ [unit]: direction });
    },
    goToday() {
      this.cursor = DateTime.now();
    },
    itemsForDate(date) {
      return this.commitments
        .filter((item) => item.date === date)
        .sort((a, b) => a.startTime.localeCompare(b.startTime));
    },
    async openForm(item, date) {
      this.form = item ? { ...item } : blank((date || this.cursor).toISODate());
      this.referenceModes = item
        ? {
            customer: this.form.customerId ? "registered" : "manual",
            responsible: this.form.responsibleId ? "registered" : "manual",
            property: this.form.propertyId ? "registered" : "manual",
            culture: this.form.cultureId ? "registered" : "manual",
          }
        : {
            customer: "registered",
            responsible: "registered",
            property: "registered",
            culture: "registered",
          };
      this.properties = [];
      if (this.form.customerId) {
        await this.loadProperties(this.form.customerId);
      }
      this.formKey += 1;
      this.showForm = true;
    },
    async save() {
      if (this.isSaving || this.isCancelling) return;
      if (!this.form.allDay && this.form.endTime <= this.form.startTime)
        return this.$toast.open({
          message: "O horário final deve ser posterior ao inicial",
          type: "warning",
        });
      if (
        !this.form.customerName ||
        !this.form.responsible ||
        !this.form.property ||
        !this.form.crop ||
        !this.form.field
      ) {
        return this.$toast.open({
          message: "Informe cliente, responsável, propriedade, cultura e talhão",
          type: "warning",
        });
      }
      this.isSaving = true;
      try {
        await apiSave(this.form);
        this.showForm = false;
        await this.load();
        this.$toast.open({
          message: "Visita agendada com sucesso",
          type: "success",
        });
      } catch (error) {
        const errors = error?.response?.data?.erros;
        this.$toast.open({
          message: errors?.join("; ") || "Não foi possível salvar o agendamento",
          type: "error",
        });
      } finally {
        this.isSaving = false;
      }
    },
    toggleReferenceMode(field) {
      const registered = this.referenceModes[field] === "registered";
      this.referenceModes[field] = registered ? "manual" : "registered";
      const fields = {
        customer: ["customerId", "customerName"],
        responsible: ["responsibleId", "responsible"],
        property: ["propertyId", "property"],
        culture: ["cultureId", "crop"],
      };
      fields[field].forEach((name) => {
        this.form[name] = "";
      });
      if (field === "customer") {
        this.form.propertyId = "";
        this.form.property = "";
        this.properties = [];
        this.referenceModes.property = this.referenceModes.customer;
      }
      this.formKey += 1;
    },
    async loadTechnicalManagers() {
      try {
        this.technicalManagers =
          (await serviceResponsible.getResponsibleForSelectBox()) || [];
      } catch (_) {
        this.technicalManagers = [];
      }
    },
    async loadProperties(customerId) {
      if (!customerId) {
        this.properties = [];
        return;
      }
      try {
        this.properties =
          (await serviceCustomerProperty.fillComobobox(customerId)) || [];
      } catch (_) {
        this.properties = [];
      }
    },
    async fillCustomers(id, query, filterType, page) {
      return serviceCustomer.fillComboBoxWithPaginate(
        id,
        query,
        filterType,
        page
      );
    },
    async fillCultures(id, query, filterType, page = 1) {
      if (id) {
        const culture = await serviceCompendio.findCultureById(id);
        return culture ? [this.normalizeCulture(culture)] : [];
      }
      const result = await serviceCompendio.findCultures(query, page);
      const cultures = Array.isArray(result) ? result : result?.data || [];
      return cultures.map(this.normalizeCulture);
    },
    normalizeCulture(culture) {
      const scientificName = culture.nomeCientifico || culture.nomecientifico;
      return {
        ...culture,
        id: String(culture.id),
        nome: scientificName
          ? `${culture.nome} (${scientificName})`
          : culture.nome,
      };
    },
    async handleCustomerSelection(customer) {
      const preserveProperty =
        String(this.form.customerId || "") === String(customer?.id || "");
      this.form.customerId = customer?.id || "";
      this.form.customerName = customer?.nome || customer?.nomeCliente || "";
      if (!preserveProperty) {
        this.form.propertyId = "";
        this.form.property = "";
      }
      await this.loadProperties(this.form.customerId);
    },
    handleResponsibleSelection(responsible) {
      this.form.responsibleId = responsible?.id || "";
      this.form.responsible = responsible?.nome || "";
    },
    handlePropertySelection(property) {
      this.form.propertyId = property?.id || "";
      this.form.property = property?.nome || "";
    },
    handleCultureSelection(culture) {
      this.form.cultureId = culture?.id || "";
      this.form.crop = culture?.nome || "";
    },
    async cancel() {
      if (!this.form.id || this.isCancelling || this.isSaving) return;
      this.isCancelling = true;
      try {
        await apiCancel(this.form.id);
        this.showForm = false;
        await this.load();
      } finally {
        this.isCancelling = false;
      }
    },
    async startVisit(item) {
      if (this.startingVisitId !== null) return;
      this.startingVisitId = item.id;
      try {
        const updated = await apiStartVisit(item.id);
        await this.load();
        this.$emit("open-inspection", updated);
      } finally {
        this.startingVisitId = null;
      }
    },
    statusClass(status) {
      return `status-${String(status)
        .toLowerCase()
        .replace(/\s/g, "-")
        .replace(/[íó]/g, "i")}`;
    },
    formatDay(date) {
      return DateTime.fromISO(date).toFormat("dd");
    },
    formatMonth(date) {
      return DateTime.fromISO(date).setLocale("pt-BR").toFormat("LLL");
    },
  },
};
</script>

<style scoped>
.agendaAgronomica {
  --agro: #006256;
  --border: #dde7e4;
  --muted: #6b7c78;
  padding: 0 0 18px 0;
  font-family: Poppins, sans-serif;
  color: #263238;
}
.agendaHeader,
.toolbar,
.agendaActions,
.navigation,
.viewButtons,
.formActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.agendaHeader {
  background: white;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 6px 18px;
}
.agendaHeader h2 {
  font-size: 16px;
  margin: 0;
}
.agendaHeader small {
  color: var(--muted);
  font-size: 12px;
}

.btnToday,
.toolbar button,
.formActions button,
.addDay {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 7px 12px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
}
.btnPrimary {
  background: #006256 !important;
  color: #fff;
  border-color: var(--agro) !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.btnSecondary {
  background: #fff;
  color: #475569;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 7px 12px;
  cursor: pointer;
  font-size: 12px;
}
.btnDanger {
  color: #b91c1c;
  border-color: #fecaca !important;
}
.summaryGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin: 6px 0;
}
.summaryCard {
  position: relative;
  display: grid;
  grid-template-columns: 42px 1fr;
  grid-template-rows: auto auto;
  padding: 14px;
  background: white;
  border: 1px solid var(--border);
  border-radius: 9px;
}
.summaryIcon {
  grid-row: 1/3;
  display: grid !important;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e5f3f0;
  color: var(--agro) !important;
  font-size: 16px !important;
}
.summaryCard strong {
  font-size: 20px;
  line-height: 1;
}
.summaryCard > span:last-child {
  font-size: 12px;
  color: var(--muted);
}
.summaryCard.warning .summaryIcon {
  background: #fff4e5;
  color: #b76e00 !important;
}
.summaryCard.danger .summaryIcon {
  background: #feeceb;
  color: #b42318 !important;
}
.summaryCard.info .summaryIcon {
  background: #eaf2ff;
  color: #175cd3 !important;
}
.toolbar {
  background: white;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 9px;
}
.navigation strong {
  font-size: 12px;
  min-width: 155px;
  text-align: center;
}
.viewButtons .active {
  background: #e5f3f0;
  color: var(--agro);
  border-color: var(--agro);
}
.monthGrid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: white;
  border: 1px solid var(--border);
  border-radius: 9px;
  overflow: hidden;
  margin-top: 10px;
}
.weekName {
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  padding: 8px;
  color: var(--muted);
  background: #f8faf9;
}
.monthDay {
  min-height: 115px;
  border: 1px solid #edf2f0;
  padding: 7px;
  cursor: pointer;
  font-size: 12px;
}
.monthDay.muted {
  background: #fafcfb;
  color: #aab5b2;
}
.monthDay.today > b {
  background: var(--agro);
  color: white;
  border-radius: 50%;
  padding: 3px 6px;
}
.eventChip {
  display: block;
  width: 100%;
  border: 0;
  border-left: 3px solid var(--agro);
  border-radius: 3px;
  background: #eaf5f2;
  text-align: left;
  font-size: 11px;
  padding: 4px;
  margin-top: 4px;
  overflow: hidden;
  white-space: nowrap;
}
.dayView {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-top: 10px;
}
.dayColumn {
  min-height: 420px;
  background: white;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px;
}
.dayColumn h3 {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  color: var(--muted);
}
.dayColumn h3 b {
  color: var(--agro);
  font-size: 15px;
}
.addDay {
  width: 100%;
  font-size: 12px;
  padding: 4px;
  border-style: dashed;
  color: var(--agro);
}
.scheduleCard,
.listItem {
  display: flex;
  flex-direction: column;
  border-left: 3px solid var(--agro);
  background: #f8fbfa;
  border-radius: 5px;
  margin-top: 7px;
  padding: 8px;
  cursor: pointer;
  font-size: 11px;
  gap: 2px;
}
.scheduleCard:hover {
  box-shadow: 0 3px 9px rgba(0, 98, 86, 0.1);
}
.startVisit {
  border: 0;
  border-top: 1px solid #dce8e5;
  background: transparent;
  color: var(--agro);
  font-weight: 600;
  font-size: 11px;
  text-align: left;
  padding: 5px 0 0;
  margin-top: 4px;
}
.status-cancelado {
  opacity: 0.55;
  border-color: #94a3b8 !important;
}
.status-concluido {
  border-color: #16a34a !important;
}
.status-em-atendimento {
  border-color: #2563eb !important;
}
.listView {
  padding: 10px 0;
}
.listItem {
  flex-direction: row;
  align-items: center;
  gap: 15px;
  font-size: 12px;
  background: white;
  border: 1px solid var(--border);
  border-left: 3px solid var(--agro);
}
.listItem .grow {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.dateBox {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.empty {
  text-align: center;
  padding: 50px;
  color: var(--muted);
}
.commitmentForm {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.formSection {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 14px;
  background: #f8fbfa;
  border: 1px solid #e3ebe8;
  border-radius: 8px;
}
.formSectionTitle {
  grid-column: 1 / -1;
  font-size: 13px;
  font-weight: 700;
  color: #006256;
  margin: 0 0 4px;
  padding-bottom: 6px;
  border-bottom: 1px solid #d7e8e1;
}
.commitmentForm label {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  gap: 3px;
}
.referenceField {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.referenceMode {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 18px;
}
.referenceMode span {
  margin-right: auto;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}
.referenceMode button {
  padding: 1px 0;
  border: 0;
  border-bottom: 1px solid currentColor;
  color: #006256;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.referenceField ::v-deep .borderInput,
.referenceField ::v-deep .vs__dropdown-toggle {
  height: 34px;
  min-height: 34px;
  border-color: #d5d3d3;
  border-radius: 6px;
}
.referenceField ::v-deep .selectPlus,
.referenceField ::v-deep .v-select {
  width: 100%;
}
.referenceField ::v-deep .vs__selected-options {
  min-width: 0;
  padding-left: 8px;
}
.referenceField ::v-deep .vs__selected {
  overflow: hidden;
  max-width: calc(100% - 22px);
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.commitmentForm input,
.commitmentForm select,
.commitmentForm textarea {
  height: 34px;
  border: 1px solid #d5d3d3;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif;
  color: #333;
  background: #fff;
  transition: border-color 0.15s;
}
.commitmentForm textarea {
  height: auto;
  resize: vertical;
}
.commitmentForm input:focus,
.commitmentForm select:focus,
.commitmentForm textarea:focus {
  outline: 0;
  border-color: #006256;
  box-shadow: 0 0 0 2px rgba(0, 98, 86, 0.1);
}
.commitmentForm .check {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.commitmentForm .check input {
  height: auto;
}
.fieldFull {
  grid-column: 1 / -1;
}
.formActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #dde7e4;
}
.formActions .spacer {
  flex: 1;
}
.modalHeader {
  background: #006256;
}
.modalBody {
  padding: 16px;
}
@media (max-width: 900px) {
  .summaryGrid {
    grid-template-columns: repeat(2, 1fr);
  }
  .dayView {
    display: flex;
    overflow: auto;
  }
  .dayColumn {
    min-width: 220px;
  }
  .monthDay {
    min-height: 85px;
  }
  .commitmentForm .formSection {
    grid-template-columns: 1fr;
  }
  .commitmentForm .formSection .fieldFull {
    grid-column: auto;
  }
}
@media (max-width: 600px) {
  .agendaHeader {
    align-items: flex-start;
    flex-direction: column;
  }
  .summaryGrid {
    grid-template-columns: 1fr;
  }
  .toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .monthGrid {
    overflow: auto;
  }
  .monthDay,
  .weekName {
    min-width: 90px;
  }
}
</style>
